import React from 'react';

const EmptyIcon: React.FC<React.PropsWithChildren<unknown>> = props => (
  <svg
    width='200'
    height='200'
    viewBox='0 0 200 200'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='200' height='200' rx='100' fill='url(#paint0_linear_181_1512)' />
    <path
      opacity='0.4'
      d='M140.25 93.5001L136.167 110.917C132.667 125.958 125.75 132.042 112.75 130.792C110.667 130.625 108.417 130.25 106 129.667L99 128C81.625 123.875 76.25 115.292 80.3333 97.8751L84.4167 80.4168C85.25 76.8751 86.25 73.7918 87.5 71.2501C92.375 61.1668 100.667 58.4584 114.583 61.7501L121.542 63.3751C139 67.4584 144.333 76.0834 140.25 93.5001Z'
      fill='#A5A7AF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M112.75 130.79C110.167 132.54 106.917 133.999 102.959 135.29L96.3754 137.457C79.8337 142.79 71.1254 138.332 65.7504 121.79L60.4171 105.332C55.0837 88.7902 59.5004 80.0402 76.042 74.7069L82.6254 72.5402C84.3337 71.9985 85.9587 71.5402 87.5004 71.2485C86.2504 73.7902 85.2504 76.8735 84.417 80.4152L80.3337 97.8735C76.2504 115.29 81.6254 123.874 99.0004 127.999L106 129.665C108.417 130.249 110.667 130.624 112.75 130.79ZM122.193 93.7234L122.193 93.7234L122.084 93.7076L101.875 88.5826C100.209 88.1659 99.2088 86.4576 99.6255 84.7909C100.042 83.1242 101.75 82.1242 103.417 82.5409L123.625 87.6659C125.292 88.0826 126.292 89.7909 125.875 91.4576C125.542 92.8326 124.25 93.7909 122.875 93.7909C122.657 93.7909 122.439 93.7591 122.193 93.7234ZM109.984 107.807C110.23 107.843 110.448 107.875 110.666 107.875C112.083 107.875 113.333 106.958 113.666 105.541C114.083 103.875 113.083 102.166 111.416 101.75L99.2912 98.6664C97.6245 98.2497 95.9162 99.2497 95.4995 100.916C95.0828 102.583 96.0828 104.291 97.7495 104.708L109.874 107.791C109.912 107.797 109.948 107.802 109.984 107.807Z'
      fill='#A5A7AF'
    />
    <defs>
      <linearGradient
        id='paint0_linear_181_1512'
        x1='36.5854'
        y1='185.366'
        x2='185.366'
        y2='31.7073'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F2F7FB' />
        <stop offset='1' stopColor='#EAEDF5' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);

export default EmptyIcon;
